import type { ComponentType } from "react";

interface DefaultPageModule {
  // React Router's route Component slot accepts page components with legacy
  // wrapper typings even though it invokes them without route-owned props.
  default: ComponentType<any>;
}

const lazyDefaultPage =
  <PageModule extends DefaultPageModule>(loadPage: () => Promise<PageModule>) =>
  async () => {
    const { default: Component } = await loadPage();

    return { Component };
  };

export { lazyDefaultPage };
